import React from 'react';
import Changelog from './Changelog';

const ChangelogContainer = () => {
  return <Changelog />;
};

export default ChangelogContainer;
